/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendSignedMRIContextRequest} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'
import {SendSignedMRIContextResponse} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'


export const sendSignedMRIContext = (request: SendSignedMRIContextRequest, options?: CashRequestOptions) => post<SendSignedMRIContextRequest, SendSignedMRIContextResponse>("/2.0/cash/send-signed-m-r-i-context", request, {...options, rejectOnError: true })